import { transactionApi } from "../../config/axiosConfig";
import { VERIFY_MANUAL_TRANSACTION } from "../constants/transaction";
import { message } from "antd";

const getVerifyManualTransaction = (id) => async (dispatch) => {
  dispatch({
    type: VERIFY_MANUAL_TRANSACTION.LOADING,
    payLoad: true,
  });

  try {
    let apiCall = await transactionApi.get(
      `transaction/verifyPaymentTrxId/${id}`
    );
    if (apiCall.status == 200) {
      dispatch({
        type: VERIFY_MANUAL_TRANSACTION.SUCCESS,
        payLoad: apiCall.data.data,
      });
      // message.success(apiCall.data.message, 3)
    }
  } catch (error) {
    dispatch({
      type: VERIFY_MANUAL_TRANSACTION.ERROR,
      payLoad: error.response
        ? error.response?.data?.error
        : "some thing went wrong",
    });
  }
};

export default getVerifyManualTransaction;

// ---------FOR MYR CURRENCY-------------------
export const getVerifyManualTransactionMyr =
  (id, endpoint, navigation) => async (dispatch) => {
    dispatch({
      type: VERIFY_MANUAL_TRANSACTION.LOADING,
      payLoad: true,
    });

    try {
      let apiCall = await transactionApi.get(
        `${endpoint == "myrfpx" ? "myrsc" : endpoint}/transaction${
          endpoint == "myrfpx" ? "myr" : endpoint
        }/verifyPaymentTrxId/${id}`
      );
        if (apiCall.data.statusCode == 200) {
        dispatch({
          type: VERIFY_MANUAL_TRANSACTION.SUCCESS,
          payLoad: apiCall.data.data,
        });
        message.success(apiCall.data.message, 3);
      }
    } catch (error) {
      dispatch({
        type: VERIFY_MANUAL_TRANSACTION.ERROR,
        payLoad: error.response
          ? error.response?.data?.error
          : "some thing went wrong",
      });
    }
  };

// ---------FOR IDR CURRENCY-------------------
export const getVerifyManualTransactionIdr = (id) => async (dispatch) => {
  dispatch({
    type: VERIFY_MANUAL_TRANSACTION.LOADING,
    payLoad: true,
  });

  try {
    let apiCall = await transactionApi.get(
      `idr/transactionidr/verifyPaymentTrxId/${id}`
    );
    if (apiCall.status == 200) {
      dispatch({
        type: VERIFY_MANUAL_TRANSACTION.SUCCESS,
        payLoad: apiCall.data.data,
      });
      message.success(apiCall.data.message, 3);
    }
  } catch (error) {
    dispatch({
      type: VERIFY_MANUAL_TRANSACTION.ERROR,
      payLoad: error.response
        ? error.response?.data?.error
        : "some thing went wrong",
    });
  }
};

// ---------FOR IDR CURRENCY-------------------
export const getVerifyManualTransactionFunc =
  (id, currencyCode) => async (dispatch) => {
    dispatch({
      type: VERIFY_MANUAL_TRANSACTION.LOADING,
      payLoad: true,
    });

    try {
      let apiCall = await transactionApi.get(
        `${currencyCode}/transaction${currencyCode}/verifyPaymentTrxId/${id}`
      );
      if (apiCall.status == 200) {
        dispatch({
          type: VERIFY_MANUAL_TRANSACTION.SUCCESS,
          payLoad: apiCall.data.data,
        });
        message.success(apiCall.data.message, 3);
      }
    } catch (error) {
      dispatch({
        type: VERIFY_MANUAL_TRANSACTION.ERROR,
        payLoad: error.response
          ? error.response?.data?.error
          : "some thing went wrong",
      });
    }
  };
